import type { ProficiencyLevel } from '@/types/competencies/ProficiencyLevel';

import { api } from '@/api/api';

export default {
    async getProficiencyLevels(): Promise<ProficiencyLevel[]> {
        const response = await api.get('/proficiencylevel');
        return response.data;
    },

    async updateProficiencyLevels(levels: ProficiencyLevel[]): Promise<ProficiencyLevel[]> {
        const response = await api.put('/proficiencylevel', { levels });
        return response.data;
    },
};
